import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import ValidationIdCurpErrorView from '../../../components/views/mx/creditoReal/ValidationIdCurpErrorView';
import {State} from '../../../types/mx/reducers';
import * as CRValidationIdActions from '../../../actions/CRValidationIdActions';
import * as ModalActions from '../../../actions/ModalActions';

const mapStateToProps = (state: State) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPressOk: (curp, token, loanApplicationToken) => {
            dispatch(CRValidationIdActions.CR_RESEND_CURP_TO_ID_VALIDATION_ACTION
                .action(curp, token, loanApplicationToken));
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
    };
};

const ValidationIdCurpErrorContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ValidationIdCurpErrorView);

export default ValidationIdCurpErrorContainer;
